export default __webpack_public_path__ + "static/media/airActiveIcon.80160d8d.svg";